import { debounce } from 'lodash';
import React, { useRef } from 'react';
import { searchClients } from '../../../ClientSearch/api/useSearchClientsQuery';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Select } from '../../../CommonComponents/OPL/Select/Select/Select';
import { Separator } from '../../../CommonComponents/OPL/Separator/Separator';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { RedtailClientOption } from '../../AddClientModal.meta';

interface Props {
  onSelect: (option: RedtailClientOption | null) => void;
}

export const RedtailImport = ({ onSelect }: Props) => {
  const loadClients = useRef(
    debounce((search: string, callback) => {
      searchClients(search, 'redtail').then(opts => {
        const options: RedtailClientOption[] = opts.map(client => {
          return {
            label: `${client.FirstName} ${client.LastName}`,
            value: client.ConsumerId ?? null,
            OnboardingEndpoint: client.OnboardingEndpoint,
          };
        });

        callback(options);
      });
    }, 300),
  ).current;

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        css={({ theme }) => ({ gap: theme.space['8'] })}
        justifyContent="center"
        width="100%"
        my="24"
      >
        <Separator width="100%" />
        <Text fontWeight={500}>or</Text>
        <Separator width="100%" />
      </Box>

      <Select<RedtailClientOption>
        isPortal
        isAsync
        isClearable
        cacheOptions
        label="Import from Redtail"
        aria-label="Import from Redtail"
        placeholder="Search contacts"
        noOptionsMessage={() => null}
        loadOptions={loadClients}
        onChange={opt => {
          onSelect(opt);
        }}
      />
    </>
  );
};
